/* eslint-disable no-magic-numbers */

export default {
  props: ['map', 'zoom', 'zoomLabels', 'zoomMin', 'zoomMax', 'currentArea'],
  methods: {
    changeZoom(value) {
      this.map.setZoom(this.zoom + value);
    },
    setZoom(zoomLevel) {
      this.map.setZoom(zoomLevel);
    },
    getZoomLevel() {
      const range = this.zoomMax - this.zoomMin;

      return `${100 - (((this.zoom - this.zoomMin) / range) * 100)}%`;
    },
    goToCurrentArea() {
      if (!this.currentArea) return;
      this.map.fitBounds(this.currentArea.getBounds());
    },
  },
  computed: {
    currentAreaZoom() {
      if (!this.currentArea) return false;

      return this.map.getBoundsZoom(this.currentArea.getBounds());
    },
  },
};
